import request from '../servises/request'

export function getNetworks (pr) {
  let params
  if (pr) {
    params = `?${pr}`
  }
  return request({
    url: pr ? `/network${params}` : '/network',
    method: 'GET',
  })
}

export function getNetworksStatuses() {
  return request({
    url: `/network/log/autotest`,
    method: 'GET',
  })
}

export function getNetworksStatistic() {
  return request({
    url: `/network/statistic`,
    method: 'GET',
  })
}

export function deleteNetwork (network_id) {
  return request({
    url: `/network/${network_id}`,
    method: 'DELETE',
  })
}

export function networkGroups () {
  return request({
    url: `/network/group/list`,
    method: 'GET',
  })
}

export function networkTags () {
  return request({
    url: `/network/tags/list`,
    method: 'GET',
  })
}

export function networkShow (network_id) {
  return request({
    url: `/network/${network_id}`,
    method: 'GET',
  })
}

export function uploadImage (file) {
  let data = new FormData()
  data.append('image', file)
  return request({
    url: `/network/upload-image`,
    method: 'POST',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  })
}

export function updateNetwork (data) {
  return request({
    url: `/network/${data.id}`,
    method: 'PATCH',
    data: data
  })
}
export function createNetwork (data) {
  return request({
    url: `/network`,
    method: 'POST',
    data: data

  })
}
